import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDFfromElement = async (element, filename = 'report.pdf') => {
  const canvas = await html2canvas(element, { scale: 2 });
  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;

  const imgProps = { width: canvas.width, height: canvas.height };
  const ratio = (pageWidth - 2 * margin) / imgProps.width;
  const imgScaledWidth = imgProps.width * ratio;
  const imgScaledHeight = imgProps.height * ratio;

  let heightLeft = imgScaledHeight;
  let position = 0;

  while (heightLeft > 0) {
    const sourceY = position / imgScaledHeight * imgProps.height;
    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = imgProps.width;
    pageCanvas.height = (pageHeight - 2 * margin) / ratio;

    const ctx = pageCanvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
    ctx.drawImage(canvas, 0, sourceY, imgProps.width, pageCanvas.height, 0, 0, imgProps.width, pageCanvas.height);

    const pageData = pageCanvas.toDataURL('image/png');
    if (position > 0) pdf.addPage();
    pdf.addImage(pageData, 'PNG', margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);

    position += pageHeight - 2 * margin;
    heightLeft -= pageHeight - 2 * margin;
  }

  pdf.save(filename);
};
